export const COMPANY_NOTE_SUFFIX =
  '[Note to Company: please also advise of any jurisdiction and foreign entity file numbers in the jurisdiction of your HQ or other material business operations]';

export function buildCompanyClause(fields) {
  const companyName = String(fields.companyName ?? '').trim() || '[Company Name]';
  const jurisdiction = String(fields.companyJurisdiction ?? '').trim() || '[Jurisdiction]';
  const fileNumber = String(fields.companyFileNumber ?? '').trim() || '[file number]';

  return `${companyName} (the "Company") incorporated in ${jurisdiction} with file number ${fileNumber}. ${COMPANY_NOTE_SUFFIX}`;
}
